<template>
  <div>
    <div class="select-none space-y-1" :class="{ 'opacity-50': disabled }">
      <label v-if="label || hasLabel" :for="id || internalId">
        <slot name="label">
          <span class="font-medium">{{ label }}</span>
        </slot>
      </label>

      <textarea
        :id="id || internalId"
        v-bind="inputBinds"
        :name="name"
        class="block w-full border p-3 text-base font-normal placeholder:text-sm placeholder:font-normal placeholder:text-gray-60"
        rows="4"
        :disabled="disabled"
        :class="[
          textAreaClasses,
          errorMessage
            ? 'border-error'
            : 'border-border-primary hover:border-border-hover focus:border-text-primary',
        ]"
        :placeholder="placeholder"
        :data-e2e-placeholder="dataE2ePlaceholder"
      />
    </div>
    <FieldHint
      v-if="!hideDetails"
      :error="Boolean(errorMessage)"
      :message="errorMessage || hint || ''"
    />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import FieldHint from "~/components/shared/FieldHint.vue";

const props = withDefaults(
  defineProps<{
    modelValue: string | number | null;
    name?: string;
    id?: string;
    label?: string;
    hideDetails?: boolean;
    disabled?: boolean;
    placeholder?: string;
    hint?: string;
    lazy?: boolean;
    textAreaClasses?: string;
    dataE2ePlaceholder?: string;
  }>(),
  {
    id: "",
    label: "",
    placeholder: "",
    hint: "",
    name: "",
    lazy: true,
    textAreaClasses: "",
  },
);

const emit = defineEmits(["update:modelValue"]);

const slots = useSlots();

const internalId = useId();

const { errorMessage, handleChange, handleBlur } = useField(
  props.name,
  undefined,
  {
    initialValue: props.modelValue,
  },
);

const hasLabel = computed(() => {
  return !!slots.label;
});

const internalValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    if (props.name) {
      handleChange(newValue);
    }
    emit("update:modelValue", newValue);
  },
});

const inputBinds = computed(() => {
  if (props.lazy) {
    return {
      value: props.modelValue,
      onChange: onInput,
      onBlur: myHandleBlur,
    };
  } else {
    return {
      value: internalValue.value,
      onInput,
    };
  }
});

function onInput(e) {
  if (props.name) {
    handleChange(e);
  }
  emit("update:modelValue", e.target.value);
}

function myHandleBlur(e) {
  handleChange(e);
  handleBlur(e);
}
</script>
